import React from 'react';
import { Box, Heading, OrderedList, ListItem } from '@chakra-ui/react';
import { StaticImage } from 'gatsby-plugin-image';
import TwoColumns from '../../components/shared/TwoColumns';

const WhyTransform = () => (
  <Box my="24">
    <TwoColumns
      reverseOrderInMobile
      col1={
        <Box>
          <Heading mb={12}>Why contractors are choosing Transform</Heading>
          <OrderedList mb={12} spacing={8} fontSize="2xl">
            <ListItem>Drives uniformity and profitability</ListItem>
            <ListItem>Unlocks efficiency and growth</ListItem>
            <ListItem>
              Accurate estimates and precise orders every time
            </ListItem>
          </OrderedList>
        </Box>
      }
      col2={
        <StaticImage
          style={{ borderRadius: '8px' }}
          src="../../images/transform-proposal.webp"
          alt="Transform Proposal"
        />
      }
    />
  </Box>
);

export default WhyTransform;
